import React from 'react'
import PropTypes from 'prop-types'
import { useTranslate } from '@chordcommerce/gatsby-theme-autonomy'
import { Button, Flex } from 'theme-ui'

import Heading from '~/components/IntlComponents/Heading'

const RedeemCard = ({ title, children, variant = 'main', fakeNavigateTo }) => {
  const translate = useTranslate()

  const boxStyle = {
    flexDirection: 'column',
    color: variant === 'main' ? 'inherit' : 'primary',
    maxWidth: '577px',
    margin: ['auto', 'unset'],
    '@media screen and (max-width: 1200px)': {
      margin: 'auto',
      flexDirection: 'column',
      textAlign: 'center',
      alignItems: 'center',
    },
  }

  const headingStyle = {
    width: '100%',
    lineHeight: '1 !important',
  }

  return (
    <Flex sx={boxStyle}>
      <Heading as="h1" variant="h1" sx={headingStyle}>
        {title}
      </Heading>
      {children}
      <Button
        data-builder-component="button"
        data-name="gift-redeem-button"
        sx={{ width: ['100%', 'fit-content'] }}
        data-testid={`redeem-button`}
        type="submit"
        variant={`buttons.gift.${variant === 'main' ? 'primary' : 'secondary'}`}
        onClick={() => fakeNavigateTo('form')}
      >
        {translate('gifting_flow.landing.redeem')}
      </Button>
    </Flex>
  )
}

RedeemCard.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.any,
  variant: PropTypes.string,
  fakeNavigateTo: PropTypes.func.isRequired,
}

export default RedeemCard
